"use client"

import { useLocale } from "@/lib/locale-context"
import { Reveal } from "@/components/reveal"
import { SectionHead } from "@/components/section-head"

/** Working roles only. Education has its own register further down. */
const WORKING_ROLES = 3

export function SectionJourney() {
  const { t } = useLocale()

  return (
    <section
      id="journey"
      className="shell scroll-mt-16 py-12 md:py-20"
      aria-labelledby="journey-heading"
    >
      <SectionHead id="journey" index="04" title={t.journey.title} lead={t.journey.lead} />

      <ol className="mt-8 md:mt-12">
        {t.journey.entries.slice(0, WORKING_ROLES).map((entry) => (
          <Reveal
            key={`${entry.year}-${entry.title}`}
            as="li"
            className="row-mark rule grid12 py-5 md:py-6"
          >
            <p className="reveal t-small col-span-12 tabular-nums text-accent md:col-span-2">
              {entry.year}
            </p>
            <div className="reveal col-span-12 mt-1 md:col-span-4 md:mt-0">
              <h3 className="t-md text-foreground">{entry.title}</h3>
              <p className="t-small mt-1 text-muted-foreground">{entry.organization}</p>
            </div>
            <p
              className="reveal t-small col-span-12 mt-2 max-w-[62ch] text-muted-foreground md:col-span-6 md:mt-0"
              style={{ ["--d" as string]: "100ms" }}
            >
              {entry.description}
            </p>
          </Reveal>
        ))}
      </ol>
    </section>
  )
}
